module.exports = "<div class=\"static-text-container\">\r\n    <label for=\"\" [innerHtml]=\"to.label\"></label>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/components/static-text/static-text.component.html
// module id = ./src/app/stage/components/static-text/static-text.component.html
// module chunks = main